<div class="footer text-white text-center d-none d-lg-block bg-secondary">
  <div class="footer-text d-none d-lg-flex h-100 pt-2">
    <iframe width="100%" height="100%" src="https://www.mlb.com/orioles/third-party-footer/" frameborder="0"></iframe>
  </div>
</div>
